// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"index_pageTitle_QA-tZ","cardTitle":"index_cardTitle_2hnqu","filledBtn":"index_filledBtn_3BQBk","requiredMark":"index_requiredMark_1hBnM","stripe0":"index_stripe0_2wLU2","stripe1":"index_stripe1_2a890","stripe":"index_stripe_2dKmV","companyName":"index_companyName_2-1m1","basicInfoList":"index_basicInfoList_21ll1","infoLabel":"index_infoLabel_1EhGE","infoValue":"index_infoValue_RPYkP","list-name":"index_list-name_-Lnsg"};
    if(module.hot) {
      // 1788760850880
      var cssReload = require("/Applications/MAMP/htdocs/ai-contact/frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"","locals":true});
      module.hot.dispose(cssReload);
      
    }
  